export default {
  basicViewItem: [{
    prop: 'status',
    label: '',
    Object: 'value'
  }, {
    prop: 'supplier',
    label: '',
    Object: 'value'
  }, {
    prop: 'created_at',
    label: '',
    Object: 'value'
  }],
  paymentHistoryTableItem: [{
    prop: 'payment_type',
    label: '',
    Object: 'value',
    width: '100'
  }, {
    prop: 'amount',
    label: '',
    Object: 'value',
    width: '100'
  }, {
    prop: 'admin_remarks',
    label: '',
    Object: 'value',
    width: '100'
  }, {
    prop: 'created_at',
    label: '',
    Object: 'value',
    width: '120'
  }]
}
